module.exports = __webpack_public_path__ + "static/media/24@2x.07879a69.png";